<template>
  <budget-view />
</template>

<script>
import BudgetView from "@/components/tools/budgets/BudgetView"

export default {
  components: {
    BudgetView
  }
}
</script>
